import { useState } from 'react';

const ASSET_CLASSES = ['LETF', 'Stock', 'Crypto', 'Future'];

export default function PositionModal({ mode, position, onSave, onClose }) {
  const isEdit = mode === 'edit';

  const [form, setForm] = useState({
    name:         position?.name         ?? '',
    assetClass:   position?.assetClass   ?? 'LETF',
    shares:       position?.shares       ?? '',
    entryPrice:   position?.entryPrice   ?? '',
    currentPrice: position?.currentPrice ?? '',
    stopPrice:    isEdit ? '' : (position?.stopPrice ?? ''),
    notes:        position?.notes        ?? '',
  });

  function set(field, value) {
    setForm(f => ({ ...f, [field]: value }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    const base = {
      name:         form.name.toUpperCase().trim(),
      assetClass:   form.assetClass,
      shares:       Number(form.shares),
      entryPrice:   Number(form.entryPrice),
      currentPrice: Number(form.currentPrice),
      notes:        form.notes.trim(),
    };
    if (isEdit) {
      onSave({ id: position.id, ...base });
    } else {
      onSave({ ...base, stopPrice: Number(form.stopPrice) });
    }
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{isEdit ? 'Edit Position' : 'Add Position'}</h3>
          <button className="modal-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-row">
            <label className="form-label">
              Name / Ticker
              <input
                type="text"
                className="form-input"
                value={form.name}
                onChange={e => set('name', e.target.value)}
                placeholder="e.g. TQQQ"
                required
                autoFocus
              />
            </label>
            <label className="form-label">
              Asset Class
              <select
                className="form-input"
                value={form.assetClass}
                onChange={e => set('assetClass', e.target.value)}
              >
                {ASSET_CLASSES.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </label>
          </div>

          <div className="form-row">
            <label className="form-label">
              Shares / Units
              <input
                type="number"
                className="form-input"
                min="0"
                step="any"
                value={form.shares}
                onChange={e => set('shares', e.target.value)}
                placeholder="0"
                required
              />
            </label>
            <label className="form-label">
              Entry Price ($)
              <input
                type="number"
                className="form-input"
                min="0"
                step="any"
                value={form.entryPrice}
                onChange={e => set('entryPrice', e.target.value)}
                placeholder="0.00"
                required
              />
            </label>
          </div>

          <div className="form-row">
            <label className="form-label">
              Current Price ($)
              <input
                type="number"
                className="form-input"
                min="0"
                step="any"
                value={form.currentPrice}
                onChange={e => set('currentPrice', e.target.value)}
                placeholder="0.00"
                required
              />
            </label>

            {!isEdit && (
              <label className="form-label">
                Stop-Loss Price ($)
                <input
                  type="number"
                  className="form-input"
                  min="0"
                  step="any"
                  value={form.stopPrice}
                  onChange={e => set('stopPrice', e.target.value)}
                  placeholder="0.00"
                  required
                />
              </label>
            )}

            {isEdit && (
              <label className="form-label">
                Stop-Loss Price ($)
                <input
                  type="text"
                  className="form-input form-input--readonly"
                  value={`$${Number(position.stopPrice).toFixed(2)}  (use Trail Stop to raise)`}
                  readOnly
                />
              </label>
            )}
          </div>

          <label className="form-label">
            Notes
            <textarea
              className="form-input position-notes-input"
              value={form.notes}
              onChange={e => set('notes', e.target.value)}
              placeholder="Why you own it, catalysts you're waiting for, special rules…"
              rows={3}
            />
          </label>

          <div className="modal-actions">
            <button type="button" className="btn btn-ghost" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary">
              {isEdit ? 'Save Changes' : 'Add Position'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
